import { render, staticRenderFns } from "./TestForm.vue?vue&type=template&id=7c25008a"
import script from "./TestForm.vue?vue&type=script&lang=js"
export * from "./TestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports